import { createUserManager } from 'redux-oidc';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';

export const SESSION_SYNC_KEY = 'pgdb_admin_session_sync';

/* eslint-disable @typescript-eslint/camelcase */
const userManagerConfig: UserManagerSettings = {
   client_id: 'admin-portal',
   redirect_uri: process.env.REACT_APP_ADMIN_REDIRECT_URL,
   response_type: 'code',
   scope: 'openid profile email pgdbAPI.full_access IdentityServerApi',
   authority: process.env.REACT_APP_IDENTITY_AUTHORITY as string,
   silent_redirect_uri: process.env.REACT_APP_ADMIN_SILENT_REDIRECT_URL,
   post_logout_redirect_uri:
      process.env.REACT_APP_ADMIN_POSTLOGOUT_REDIRECT_URL,
   automaticSilentRenew: true,
   monitorSession: false,
   filterProtocolClaims: true,
   loadUserInfo: true,
   userStore: new WebStorageStateStore({ store: localStorage }),
};

const userManager = createUserManager(userManagerConfig);

// Reload when another tab completes a login or logout so all tabs stay in sync.
// The storage event only fires in tabs that did NOT make the change.
window.addEventListener('storage', (event: StorageEvent): void => {
   if (event.key === SESSION_SYNC_KEY || event.key === null) {
      window.location.reload();
   }
});

export default userManager;
